import { useNavigate } from 'react-router-dom'
import SolverLayout from '../layout/SolverLayout'
import LearningContainer from './LearningContainer'
import WrongQuizHeader from './WrongQuizHeader'
import solverStyles from '../../styles/user/Solver.module.scss'

const LearningQuizOnly = () => {
  const navigate = useNavigate()

  const handleQuizComplete = () => {
    navigate('/activitySummary')
  }

  return (
    <SolverLayout>
      <WrongQuizHeader />
      <div className={solverStyles.solverPageWrapper}>
        <LearningContainer mode="quizOnly" onQuizComplete={handleQuizComplete} />
      </div>
    </SolverLayout>
  )
}

export default LearningQuizOnly
